import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  return (
    <section className="py-12 md:py-24 bg-slate-900 relative overflow-hidden" id="contact-cta">
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-96 h-96 bg-secondary/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10 text-center">
        <h2 className="font-display text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
          Ready for Your <span className="text-primary italic">Perfect Smile?</span>
        </h2>
        <p className="text-slate-400 text-lg mb-10 max-w-2xl mx-auto font-light">
          Book your consultation today at our VIP Center in Kottawa. <br />
          Experience dental care that puts your comfort first.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
          <a
            className="bg-primary hover:bg-primaryDark text-white font-bold px-10 py-4 rounded-full text-lg shadow-glow transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center gap-3 w-full sm:w-auto"
            href="tel:+94777880894"
          >
            <i className="fas fa-phone-alt text-xl"></i>
            Contact Us
          </a>
          <Link to="/treatments" className="bg-transparent hover:bg-white/5 border border-slate-700 text-white px-10 py-4 rounded-full text-lg font-medium transition-all duration-300 backdrop-blur-sm w-full sm:w-auto flex justify-center items-center">
            View Treatments
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
